<template>
  <v-btn
    v-tooltip="buttonText"
    :loading="$loading.isLoading('handleExport')"
    border
    color="white"
    density="comfortable"
    icon="mdi-light:printer"
    @click.stop="handleExport">
  </v-btn>
</template>

<script lang="ts">
import { handleAsync } from 'best-modules/plugins'
import { download } from 'best-modules/vue-utils'

export default {
  name: 'ExportPfForm',
  props: {
    url: { type: Function, required: true },
    buttonText: { type: String, required: true },
    exportFileName: { type: String, required: true },
  },
  setup(props) {
    const handleExport = () => {
      return handleAsync('handleExport', () => {
        return props.url().then((res: any) => {
          if (res.url) {
            return download(res.url, props.exportFileName)
          }
        })
      })
    }

    return {
      handleExport,
    }
  },
}
</script>

<style scoped></style>
